export default {
    namespaced: true,
    state: {
        isGlobalControlLocked: false
    },
    mutations: {
        setGlobalControlLockStatus(state, isLocked) {
            state.isGlobalControlLocked = isLocked
        }
    }
}
